import { omitBy, isEmpty } from "lodash";
import { useRouter } from "next/router";
import { useCookies } from "react-cookie";
import { getQueryParams } from "~/utils/common";

interface UtmParams {
  utm_campaign?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_content?: string;
  utm_page?: string;
  utm_segment?: string;
  utm_blog?: string;
  others?: string;
}

const useUtmParams = (): UtmParams => {
  const router = useRouter();
  const {
    utm_campaign,
    utm_source,
    utm_medium,
    utm_content,
    utm_page,
    utm_segment,
    utm_blog,
  } = router.query as Record<string, string | undefined>;

  const isBlog = router.asPath.includes("resources/b");
  const [cookies] = useCookies(["utm_source", "utm_blog", "others"]);

  const getUtmSource = (): string | undefined => {
    if (isBlog) {
      return cookies.utm_source || "blog";
    }
    return cookies.utm_source || utm_source || undefined;
  };

  const utmParams: UtmParams = {
    utm_source: getUtmSource(),
    utm_campaign,
    utm_medium,
    utm_content,
    utm_page,
    utm_segment,
    utm_blog: isBlog ? cookies.utm_blog : utm_blog,
    others: cookies.others || getQueryParams(router.asPath),
  };

  return omitBy(utmParams, isEmpty);
};

export default useUtmParams;
